import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const AccountIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M28.799 29.217c0 1.534-1.276 2.782-2.844 2.782h-4.302a.704.704 0 01-.711-.696v-5.888c0-.767-.638-1.391-1.422-1.391h-7.005c-.784 0-1.422.624-1.422 1.391v5.888a.704.704 0 01-.711.696H6.045c-1.569 0-2.844-1.248-2.844-2.782V2.783C3.201 1.248 4.477 0 6.045 0h19.911C27.525 0 28.8 1.248 28.8 2.783v26.434zM13.046 26v6h5.908v-6h-5.908zM24.861 4h-3.938v4h3.938V4zm0 7h-3.938v4h3.938v-4zm0 7h-3.938v4h3.938v-4zM14.03 18v4h3.938v-4H14.03zm3.939-7h-3.938v4h3.938v-4zM7.138 18v4h3.938v-4H7.138zM14.03 4v4h3.938V4H14.03zm-2.953 0H7.139v4h3.938V4zm-3.939 7v4h3.938v-4H7.138z"
  }));
};
export default /*#__PURE__*/memo(AccountIcon);